import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import eventService from "../Services/Service";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "../styles/Religion.css";

import {
  Button,
  Modal,
  Box,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const EventManager = () => {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState({ id: "0", name: "" });
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    eventService.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Event");
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    const res = await eventService.getAll();
    setEvents(res.data);
  };

  const clear = () => {
    setForm({ id: "0", name: "" });
    setEditing(false);
  };

 const handleBlur = (e) => {
  const value = e.target.value.trim();

  setForm((prev) => ({
    ...prev,
    name: value,
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();

      // Trim leading and trailing spaces
  const eventName = form.name.trim();

  // 1. Required validation
  if (!eventName) {
    setSnackbar({
      open: true,
      message: "Event Name is required",
      severity: "error",
    });
    return;
  }

  // 2. Reject special-character-only values
  if (!/[\p{L}\p{N}]/u.test(eventName)) {
    setSnackbar({
      open: true,
      message: "Event Name must contain at least one letter or number",
      severity: "error",
    });
    return;
  }

  // 3. Duplicate validation - case insensitive
  // During edit, exclude the current record
  const duplicate = events.some(
    (r) =>
      r.eventName?.trim().toLowerCase() === eventName.toLowerCase() &&
      String(r.eventId) !== String(form.id)
  );

  if (duplicate) {
    setSnackbar({
      open: true,
      message: "Event Name already exists",
      severity: "error",
    });
    return;
  }


    const response = await eventService.create({
      EventId: form.id,
      EventName: eventName,
      OpFlag: editing ? "Update" : "Insert",
      UserName: sessionStorage.getItem("userEmail"),
    });

    let vOutput = response.data.message.split(":");

    clear();
    fetchEvents();
    setOpen(false);

    setSnackbar({
      open: true,
      message: vOutput[0],
      severity: vOutput[1],
    });
  };

  const handleEdit = (row) => {
    setForm({
      id: row.eventId,
      name: row.eventName,
    });

    setEditing(true);
    setOpen(true);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    const response = await eventService.remove(deleteId, "Delete");
    let vOutput = response.data.message.split(":");

    fetchEvents();

    setSnackbar({
      open: true,
      message: vOutput[1],
      severity: vOutput[0],
    });

    setConfirmOpen(false);
  };

  const columns = [
    {
      field: "serialNo",
      headerName: "No.",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    {
      field: "eventId",
      headerName: "ID",
    },
    {
      field: "eventName",
      headerName: "Event Name",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            height: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ModeEditOutlineRoundedIcon />}
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<DeleteRoundedIcon />}
            onClick={() => handleDelete(params.row.eventId)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="religion-grid-wrapper">
      <Box sx={{ p: 4 }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/DashboardFinal")}
          >
            Back To Home
          </Button>

          <Button variant="contained" onClick={() => setOpen(true)}>
            Add Event
          </Button>
        </Box>

        <div className="datagrid-container">
          <DataGrid
            rows={events}
            columns={columns}
            columnVisibilityModel={{
              eventId: false,
            }}
            getRowId={(row) => row.eventId}
            components={{ Toolbar: GridToolbar }}
          />
        </div>
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{ p: 3, bgcolor: "#fff", m: "auto", mt: 10, width: 400 }}>
          <h4>{editing ? "Edit" : "Add"} Event</h4>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Event Name"
              fullWidth
              required
              value={form.name}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, name: e.target.value }))
              }
              // onBlur={handleBlur}
            />

            <Box mt={2} textAlign="right">
              <Button
                onClick={() => {
                  setOpen(false);
                  clear();
                }}
              >
                Cancel
              </Button>

              <Button type="submit" variant="contained">
                Save
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this event?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>

          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default EventManager;
